"use client";

import createIcon from './util/createIcon';
export default createIcon('M20.84 22.73L19.11 21H3V4.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 3H6.2L21 17.8V3Z', 'SquareOff');